import React from "react";
import WidgetDeployments from "./WidgetDeploymentsTables";
import { ChromePicker } from "react-color";
import WidgetDeployLogic from "./WidgetDeployLogic";

export default function WidgetDeploy(props) {
  const {
    isDarkMode,
    styles,
    isLoading,
    isEditing,
    isWidgetDeployed,
    widgetScript,
    deployments,
    flows,

    title, setTitle,
    titleError,
    description, setDescription,
    flow, setFlow,

    primaryColor, setPrimaryColor,
    headerColor, setHeaderColor,
    userBubbleColor, setUserBubbleColor,
    assistantBubbleColor, setAssistantBubbleColor,
    backgroundGradientFrom, setBackgroundGradientFrom,
    backgroundGradientTo, setBackgroundGradientTo,
    footerColor, setFooterColor,

    headerTextColor, setHeaderTextColor,
    userTextColor, setUserTextColor,
    assistantTextColor, setAssistantTextColor,
    buttonHoverColor, setButtonHoverColor,
    buttonIconColor, setButtonIconColor,

    headerIcon, setHeaderIcon,
    headerTitle, setHeaderTitle,
    initialMessage, setInitialMessage,
    stockReply, setStockReply,
    
    popupMessage, setPopupMessage,
    popupTimer, setPopupTimer,
    showPopupOptions, togglePopupOptions,
    handlePopupTimerChange,

    showColorPanel,
    toggleColorPanel,

    handleEdit,
    handleDelete,
    handleTitleChange,
    copyScriptToClipboard,
    resetToDefaults,
    handleSubmit,
    handleShowScript,
    copyButtonText
  } = WidgetDeployLogic(props);

  // Decide card container classes based on dark mode
  const cardClass = `widget-card ${isDarkMode ? 'widget-card-dark' : ''}`;
  const previewClass = `widget-preview ${isDarkMode ? 'widget-preview-dark' : ''}`;

  return (
    <div style={styles.wrapper}>
      <div className="App" style={{ ...styles.body, paddingTop: "50px" }}>
        <h1 style={{ ...styles.h1, marginBottom: '0.5rem' }}>Chat Widget Deployment</h1>
        <p style={{ fontSize: '0.95rem', lineHeight: '1.5' }}>
          Create customizable chat widgets for your website. Each deployment is $10/mo. Click deploy. Copy the script. Paste on your website.
        </p>

        {/* MAIN CARD */}
        <div className={cardClass}>
          <form onSubmit={handleSubmit} className="widget-form">
            {/* Title & Description */}
            <div className="widget-2col-section">
              <div style={{ flex: '1 1 250px', minWidth: '250px' }}>
                <label style={styles.yourmsglabel}>Widget Title</label>
                <input
                  type="text"
                  value={title}
                  onChange={handleTitleChange}
                  className={isDarkMode ? 'sleek-input-api-dark' : 'sleek-input-api-light'}
                  style={{ width: '100%' }}
                  placeholder="e.g. MyWebsiteChat"
                />
                {titleError && (
                  <span style={{ color: 'red', fontSize: '0.8em' }}>{titleError}</span>
                )}
              </div>

              <div style={{ flex: '1 1 250px', minWidth: '250px' }}>
                <label style={styles.yourmsglabel}>Description</label>
                <input
                  type="text"
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  className={isDarkMode ? 'sleek-input-api-dark' : 'sleek-input-api-light'}
                  style={{ width: '100%' }}
                  placeholder="Brief description of this widget"
                />
              </div>
            </div>

            {/* Flow Selection */}
            <div className="widget-2col-section">
              <div style={{ flex: '1 1 250px', minWidth: '250px' }}>
                <label style={styles.yourmsglabel}>Select Flow</label>
                <select
                  value={flow}
                  onChange={e => setFlow(e.target.value)}
                  className={isDarkMode ? 'sleek-select-dark' : 'sleek-select-light'}
                  style={{ width: '100%' }}
                >
                  <option value="">-- Choose a flow --</option>
                  {flows.map((flowName, index) => (
                    <option key={index} value={flowName}>{flowName}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Header Icon & Title */}
            <div className="widget-2col-section">
              <div style={{ flex: '1 1 250px', minWidth: '250px' }}>
                <label style={styles.yourmsglabel}>Header Title</label>
                <input
                  type="text"
                  value={headerTitle}
                  onChange={e => setHeaderTitle(e.target.value)}
                  className={isDarkMode ? 'sleek-input-api-dark' : 'sleek-input-api-light'}
                  style={{ width: '100%' }}
                  placeholder="e.g. Support Chat"
                />
              </div>

              <div style={{ flex: '1 1 250px', minWidth: '250px' }}>
                <label style={styles.yourmsglabel}>Header Icon (URL)</label>
                <input
                  type="text"
                  value={headerIcon}
                  onChange={e => setHeaderIcon(e.target.value)}
                  placeholder="https://example.com/icon.png"
                  className={isDarkMode ? 'sleek-input-api-dark' : 'sleek-input-api-light'}
                  style={{ width: '100%' }}
                />
              </div>
            </div>

            {/* Messages */}
            <div className="widget-2col-section">
              <div style={{ flex: '1 1 250px', minWidth: '250px' }}>
                <label style={styles.yourmsglabel}>Initial Message</label>
                <textarea
                  value={initialMessage}
                  onChange={e => setInitialMessage(e.target.value)}
                  style={{ ...styles.textarea, fontSize: '.9rem', width: '100%', paddingLeft: '8px' }}
                  placeholder="What the assistant says first"
                />
              </div>

              <div style={{ flex: '1 1 250px', minWidth: '250px' }}>
                <label style={styles.yourmsglabel}>Fallback Reply</label>
                <textarea
                  value={stockReply}
                  onChange={e => setStockReply(e.target.value)}
                  style={{ ...styles.textarea, fontSize: '.9rem', width: '100%', paddingLeft: '8px' }}
                  placeholder="Message shown when AI fails"
                />
              </div>
            </div>

            {/* POPUP SETTINGS BUTTON */}
            <div style={{ display: 'flex', gap: '1rem', margin: '1rem 0' }}>
              <button
                type="button"
                className="link-button"
                onClick={togglePopupOptions}
              >
                {showPopupOptions ? 'Hide Popup Options' : 'Show Popup Options'}
              </button>
            </div>

            {/* POPUP SETTINGS PANEL */}
            {showPopupOptions && (
              <div className="popup-panel" style={{ 
                padding: '1rem', 
                marginBottom: '1.5rem', 
                border: '1px solid #ddd', 
                borderRadius: '8px',
                backgroundColor: isDarkMode ? '#0d0d0d' : '#ffffff' 
              }}>
                <h3 style={{ marginTop: 0, marginBottom: '1rem' }}>Popup Message Settings</h3>
                
                <div className="widget-2col-section">
                  <div style={{ flex: '1 1 250px', minWidth: '250px' }}>
                    <label style={styles.yourmsglabel}>Popup Message</label>
                    <textarea
                      value={popupMessage}
                      onChange={e => setPopupMessage(e.target.value)}
                      style={{ ...styles.textarea, fontSize: '.9rem', width: '100%', paddingLeft: '8px' }}
                      placeholder="Message to show in popup (leave empty for no popup)"
                    />
                    <p style={{ fontSize: '0.8rem', margin: '0.25rem 0 0', color: isDarkMode ? '#999999' : '#6b7280' }}>
                      Leave empty to disable popup message
                    </p>
                  </div>

                  <div style={{ flex: '1 1 250px', minWidth: '250px' }}>
                    <label style={styles.yourmsglabel}>Popup Timer (ms)</label>
                    <input
                      type="number"
                      value={popupTimer}
                      onChange={handlePopupTimerChange}
                      min="0"
                      step="1000"
                      className={isDarkMode ? 'sleek-input-api-dark' : 'sleek-input-api-light'}
                      style={{ width: '100%' }}
                      placeholder="5000"
                    />
                    <p style={{ fontSize: '0.8rem', margin: '0.25rem 0 0', color: isDarkMode ? '#999999' : '#6b7280' }}>
                      Time in milliseconds before showing popup (5000 = 5 seconds)
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* COLOR SETTINGS BUTTONS */}
            <div style={{ display: 'flex', gap: '1rem', margin: '1rem 0' }}>
              <button
                type="button"
                className="link-button"
                onClick={toggleColorPanel}
              >
                {showColorPanel ? 'Hide Colors' : 'Show Colors'}
              </button>
              
              <button
                type="button"
                className="link-button"
                onClick={resetToDefaults}
              >
                Reset
              </button>
            </div>

            {/* COLOR SETTINGS PANEL */}
            {showColorPanel && (
              <div className="color-panel">
                <div>
                  <label style={styles.yourmsglabel} title="--widget-primary: Background of the closed chat button and Send button; input focus accents.">Primary Color</label>
                  <ChromePicker
                    color={primaryColor}
                    onChange={color => setPrimaryColor(color.hex)}
                    disableAlpha
                  />
                </div>

                <div>
                  <label style={styles.yourmsglabel} title="--widget-header: Background color of the chat header bar.">Header BG</label>
                  <ChromePicker
                    color={headerColor}
                    onChange={color => setHeaderColor(color.hex)}
                    disableAlpha
                  />
                </div>

                <div>
                  <label style={styles.yourmsglabel} title="--widget-footer-bg: Background color of the chat footer/input bar.">Footer BG</label>
                  <ChromePicker
                    color={footerColor}
                    onChange={color => setFooterColor(color.hex)}
                    disableAlpha
                  />
                </div>

                <div>
                  <label style={styles.label} title="--widget-header-text: Text and icon color in the header.">Header Text</label>
                  <ChromePicker
                    color={headerTextColor}
                    onChange={color => setHeaderTextColor(color.hex)}
                    disableAlpha
                  />
                </div>

                <div>
                  <label style={styles.label} title="--widget-user-bubble: Background color of the user’s message bubbles.">User Bubble</label>
                  <ChromePicker
                    color={userBubbleColor}
                    onChange={color => setUserBubbleColor(color.hex)}
                    disableAlpha
                  />
                </div>

                <div>
                  <label style={styles.label} title="--widget-user-text: Text color inside the user’s message bubbles.">User Text</label>
                  <ChromePicker
                    color={userTextColor}
                    onChange={color => setUserTextColor(color.hex)}
                    disableAlpha
                  />
                </div>

                <div>
                  <label style={styles.label} title="--widget-assistant-bubble: Background color of the assistant’s message bubbles.">Assistant Bubble</label>
                  <ChromePicker
                    color={assistantBubbleColor}
                    onChange={color => setAssistantBubbleColor(color.hex)}
                    disableAlpha
                  />
                </div>

                <div>
                  <label style={styles.label} title="--widget-assistant-text: Text color inside the assistant’s message bubbles.">Assistant Text</label>
                  <ChromePicker
                    color={assistantTextColor}
                    onChange={color => setAssistantTextColor(color.hex)}
                    disableAlpha
                  />
                </div>

                <div>
                  <label style={styles.label} title="--widget-button-hover: Hover background for the Send button and the closed chat button.">Button Hover</label>
                  <ChromePicker
                    color={buttonHoverColor}
                    onChange={color => setButtonHoverColor(color.hex)}
                    disableAlpha
                  />
                </div>

                <div>
                  <label style={styles.label} title="--widget-button-icon: Icon color of the floating chat bubble when the chat is closed.">Button Icon</label>
                  <ChromePicker
                    color={buttonIconColor}
                    onChange={color => setButtonIconColor(color.hex)}
                    disableAlpha
                  />
                </div>

                <div>
                  <label style={styles.label} title="--widget-bg-from: Start color of the chat panel background gradient.">BG Gradient Start</label>
                  <ChromePicker
                    color={backgroundGradientFrom}
                    onChange={color => setBackgroundGradientFrom(color.hex)}
                    disableAlpha
                  />
                </div>

                <div>
                  <label style={styles.label} title="--widget-bg-to: End color of the chat panel background gradient.">BG Gradient End</label>
                  <ChromePicker
                    color={backgroundGradientTo}
                    onChange={color => setBackgroundGradientTo(color.hex)}
                    disableAlpha
                  />
                </div>
              </div>
            )}

            {/* LIVE PREVIEW */}
            {/* <label style={{ ...styles.yourmsglabel, marginTop: '1rem' }}>Live Preview</label> */}
            <div className={previewClass} style={{marginTop: '10px'}}>
              <div
                className="widget-header"
                style={{
                  backgroundColor: headerColor,
                  color: headerTextColor,
                  paddingBottom: "20px"
                }}
              >
                <div className="widget-header-left">
                  {headerIcon ? (
                    <img
                      src={headerIcon}
                      alt="Header icon"
                      style={{ width: '20px', height: '20px' }}
                      onError={e => { e.target.style.display = 'none'; }}
                    />
                  ) : (
                    <div style={{
                      width: '20px',
                      height: '20px',
                      backgroundColor: 'rgba(255,255,255,0.2)',
                      borderRadius: '4px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      💬
                    </div>
                  )}
                  <span style={{ fontWeight: 'bold' }}>{headerTitle}</span>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <span>🗑️</span>
                  <span>✕</span>
                </div>
              </div>

              <div
                className="widget-preview-body"
                style={{
                  background: `linear-gradient(to bottom right, ${backgroundGradientFrom}, ${backgroundGradientTo})`,
                  padding: '1rem',      
                  minHeight: '200px',
                  position: 'relative'
                }}
              >
                {/* Assistant Message */}
                <div
                  className="widget-message"
                  style={{
                    backgroundColor: assistantBubbleColor,
                    color: assistantTextColor
                  }}
                >
                  {initialMessage}
                </div>

                {/* User Message */}
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <div
                    className="widget-message widget-message-user"
                    style={{
                      backgroundColor: userBubbleColor,
                      color: userTextColor
                    }}
                  >
                    Sample user message
                  </div>
                </div>
                
                {/* Popup Preview (if message is set) */}
                {popupMessage && (
                  <div style={{ 
                    marginTop: '1rem', 
                    padding: '10px', 
                    backgroundColor: '#f8f9fa', 
                    border: '1px dashed #ddd',
                    borderRadius: '8px' 
                  }}>
                    <span style={{ fontSize: '0.8rem', color: '#999999', fontStyle: 'italic' }}>Popup preview:</span>
                    <div style={{
                      marginTop: '5px',
                      backgroundColor: 'white',
                      padding: '10px',
                      borderRadius: '8px',
                      boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                      position: 'relative'
                    }}>
                      {popupMessage}
                      <div style={{
                        position: 'absolute',
                        bottom: '-8px',
                        right: '20px',
                        width: '16px',
                        height: '8px',
                        overflow: 'hidden'
                      }}>
                        <div style={{
                          position: 'absolute',
                          width: '12px',
                          height: '12px',
                          backgroundColor: 'white',
                          transform: 'rotate(45deg)',
                          top: '-6px',
                          left: '2px',
                          boxShadow: '2px 2px 3px rgba(0,0,0,0.05)'
                        }}></div>
                      </div>
                    </div>
                    <div style={{ fontSize: '0.8rem', color: '#999999', marginTop: '5px' }}>
                      Will appear after {popupTimer/1000} seconds
                    </div>
                  </div>
                )}

                {/* Closed Chat Button Preview */}
                <div
                  title="Floating chat button preview"
                  style={{
                    position: 'absolute',
                    right: '16px',
                    bottom: '16px',
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    backgroundColor: primaryColor,
                    boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'default'
                  }}
                >
                  <span style={{ color: buttonIconColor, fontSize: '20px', lineHeight: 1 }}>💬</span>
                </div>
              </div>
            </div>

            {/* DEPLOY / UPDATE BUTTON */}
            <button
              type="submit"
              style={{...styles.button, marginTop: '40px'}}
            >
              {isEditing ? 'Update Widget' : 'Deploy Widget'}
            </button>

            {/* LOADING SPINNER */}
            {isLoading && (
              <div className="loading-spinner" style={{ display: 'block' }}>
                <svg viewBox="0 0 50 50">
                  <circle cx="25" cy="25" r="20" stroke="#00d67a" strokeWidth="5" fill="none" />
                </svg>
              </div>
            )}
          </form>
        </div>

        {/* EMBED SCRIPT SECTION */}
        {isWidgetDeployed && !isEditing && (
          <div style={{ marginTop: '2rem', paddingTop: '1.5rem', borderTop: '1px solid #ddd' }}>
            <h3 style={{ marginBottom: '0.5rem' }}>Widget Embed Script</h3>
            <p style={{ fontSize: '0.9rem', lineHeight: '1.4' }}>
              Copy and paste this script into your website's HTML (just before the <code>&lt;/header&gt;</code> tag):
            </p>

            <div style={{ position: 'relative', marginTop: '1rem' }}>
              <textarea
                readOnly
                className={isDarkMode ? 'sleek-textarea-dark' : 'sleek-textarea-light'}
                ref={r => r && (r.value = widgetScript)}
                style={{
                  ...styles.textarea,
                  minHeight: '150px',
                  fontFamily: 'monospace',
                  fontSize: '0.85em',
                  whiteSpace: 'pre',
                  overflowX: 'auto',
                  padding: '1rem'
                }}
              />
              <button
                onClick={copyScriptToClipboard}
                style={{
                  ...styles.button,
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  padding: '5px 10px',
                  fontSize: '0.85em'
                }}
              >
                {copyButtonText}
              </button>
            </div>

            <ul style={{ marginTop: '1rem', lineHeight: '1.6', fontSize: '0.9rem' }}>
              <li>Paste this script before the closing <code>&lt;/header&gt;</code> tag on your site.</li>
              <li>The widget will appear in the bottom-right corner automatically.</li>
            </ul>
          </div>
        )}

        {/* EXISTING DEPLOYMENTS */}
        <div style={{ marginTop: '3rem' }}>
          <h2 style={{ marginBottom: '1rem' }}>Your Widget Deployments</h2>
          <WidgetDeployments
            isDarkMode={isDarkMode}
            depsBrah={deployments}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onShowScript={handleShowScript}
          />
        </div>
      </div>
    </div>
  );
}